import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ApiBackendClient } from '../../helpers/api_backend_helper';

const useOrdenesTrabajo = (fechaDesde, fechaHasta) => {
    const [ordenes, setOrdenes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);

    const apiBackendClient = new ApiBackendClient();

    useEffect(() => {
        const fetchOrdenes = async () => {
            // Validar que tenemos todos los datos necesarios
            if (!tenantId || !empresa || !departamento || !fechaDesde || !fechaHasta) {
                setError('Faltan datos requeridos: tenantId, empresa, departamento o fechas');
                setLoading(false);
                return;
            }

            setLoading(true);
            setError(null);

            try {
                // Preparar parámetros para la consulta
                const params = {
                    tenantId,
                    empresa,
                    departamento,
                    taller: departamento,
                    fechaDesde,
                    fechaHasta
                };

                // Construir URL
                const url = `/st_ordtra/${empresa}`;

                console.log('Consultando órdenes de trabajo:', { url, params });

                // Usar ApiBackendClient para la consulta
                const response = await apiBackendClient.get(url, params);

                console.log('Respuesta órdenes de trabajo:', response);

                // La respuesta ya viene procesada por el interceptor de axios
                if (response && response.success) {
                    setOrdenes(response.records || []);
                } else {
                    throw new Error(response?.message || 'Error al obtener órdenes de trabajo');
                }
            } catch (err) {
                console.error('Error en useOrdenesTrabajo:', err);
                // El interceptor de axios ya formatea el error
                const errorMessage = typeof err === 'string' ? err : (err.message || 'Error desconocido al cargar órdenes de trabajo');
                setError(errorMessage);
                setOrdenes([]);
            } finally {
                setLoading(false);
            }
        };

        fetchOrdenes();
    }, [tenantId, empresa, departamento, fechaDesde, fechaHasta]);

    return { ordenes, loading, error };
};

export default useOrdenesTrabajo;
